<template>
    <div class="calls">
      <div class="call-type">
        <form @submit.prevent="onSubmit">
          <div class="form-group">
            <div class="row p-0">
              <!-- Call Type -->
              <div class="col-sm-3 m-0 p-1">
                <v-select
                  v-model="form.call_type"
                  :items="$optionHelper.dropDownOptionArray(call_type)"
                  item-title="label"
                  item-value="code"
                  label="Call"
                  return-object
                  density="compact"
                  variant="solo"
                  hide-details
                  class="full-width"
                />
              </div>
  
              <!-- Rule -->
              <div class="col-sm-3 m-0 p-1">
                <v-select
                  v-model="form.rule"
                  :items="$optionHelper.dropDownOptionArray(rule)"
                  item-title="label"
                  item-value="code"
                  label="Rule"
                  taggable
                  density="compact"
                  variant="solo"
                  hide-details
                  class="full-width"
                />
              </div>
  
              <!-- Value -->
              <div class="col-sm-2 m-0 p-1">
                <v-text-field
                  v-model="form.value.value"
                  label="Value"
                  placeholder="Value"
                  density="compact"
                  variant="solo"
                  hide-details
                  class="full-width"
                />
              </div>
  
              <!-- Qty -->
              <div class="col-sm-2 m-0 p-1">
                <v-text-field
                  v-model="form.qty"
                  label="Qty"
                  placeholder="Qty"
                  density="compact"
                  variant="solo"
                  hide-details
                  class="full-width"
                />
              </div>
  
              <!-- Save/Delete Buttons -->
              <div class="col-sm-2 m-0 p-1">   
                <div class="d-flex align-center justify-center" style="gap: 6px;">
                    <v-btn
                        icon
                        size="x-small"
                        variant="flat"
                        class="square-icon-btn"
                        @click="saveRow(row)"
                        title="Save"
                    >
                        <v-icon size="20" color="success">fas fa-save</v-icon>
                    </v-btn>

                    <v-btn
                        icon
                        size="x-small"
                        variant="flat"
                        class="square-icon-btn"
                        @click="deleteRow(row)"
                        title="Delete"
                    >
                        <v-icon size="20" color="error">fas fa-trash</v-icon>
                    </v-btn>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </template>
  

<style scoped>
    .square-icon-btn {
        width: 34px;
        height: 40px;
        min-width: 34px !important;
        min-height: 40px !important;
        border: 1px solid var(--border);
        border-radius: 8px; /* for slight rounding; change to 0 if you want strict square */
        padding: 0;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .square-icon-btn:hover {
        background-color: var(--light);
    }
</style>

  
<script>

import gql from 'graphql-tag'

const ADD_THREAD_QUERY = gql`
mutation addThread($threadId: ID, $name: String, $typeId: Int, $callType: String, $qty: String, $stock: [String], $target: String, $rule: String, $value: ValueOption) {
    addThread(thread_id: $threadId, name: $name, type_id: $typeId, call_type: $callType, qty: $qty stock: $stock, target: $target, rule: $rule, value: $value) {
        thread_id
        name
        type_id
        rule
        status
    }
}`;

const DELETE_THREAD = gql`
mutation DeleteThread($threadId: ID!) {
  deleteThread(thread_id: $threadId)
}`;

export default {
    name: 'tracker-call-row',
    data() {
    return {
        form: {
        call_type: this.row.call_type,
        qty: this.row.qty,
        rule: this.row.rule ? JSON.parse(this.row.rule).rule : '',
        value: {
            value: this.row.rule ? JSON.parse(this.row.rule).value.value : '',
        },
        },
        call_type: [{'1': 'Buy', '2': 'Sell'}],
        rule: [{'=': '=', '>': '>', '<': '<'}],
    }
    },
    props: {
        row: { type: Object },
        stockId: { type: Number },
        name: {type: String}
    },

    created() {
        const selectedCode = '1'; // or '2', from backend
        const options = this.$optionHelper.dropDownOptionArray(this.call_type);

        this.form.call_type = options.find(opt => opt.code === selectedCode) || null;
    },
    methods: {
    async deleteRow(row){
        if(typeof row.thread_id != 'undefined'){
            await this.$apollo.mutate({
                mutation: DELETE_THREAD,
                variables: {
                    "threadId": row.thread_id,
                },
            }).then(() => {
                this.$parent.dataRows = this.$parent.dataRows.filter(it => it !== row);
            }).catch((error) => {
                // This is a real ApolloError (from $apollo.mutate), not the
                // plain-string rejection fetch-wrapper.js produces -- its
                // .message is a genuine, readable reason (especially now
                // that main.ts loads Apollo's dev error messages), safe and
                // useful to show directly rather than a generic fallback.
                console.error('Delete thread failed:', error);
                this.alertStore$.error(error?.message || 'Failed to delete thread.');
            });
        } else {
            this.$parent.dataRows = this.$parent.dataRows.filter(it => it !== row);
        }
    },
    saveRow(row){
        try {
            let isNewRow = row.thread_id ? false : true;
            const ruleCode = this.form.rule?.code ?? this.form.rule;
            const callTypeCode = this.form.call_type?.code?.toString() ?? this.form.call_type?.toString() ?? "";
            const callTypeLabel = callTypeCode === "1" ? "Buy" : "Sell";

            this.$apollo.mutate({
                mutation: ADD_THREAD_QUERY,
                variables: {
                    "threadId"  : row.thread_id,
                    "name"      : this.name +' '+ ruleCode +' '+ this.form.value.value +' '+ callTypeLabel +' '+ this.form.qty,
                    "stock"     : [this.stockId.toString()],
                    "target"    : "market_price",
                    "rule"      : ruleCode,
                    "value"     : {value: this.form.value.value, from: "", to: "", day: ""},
                    "typeId"    : 2,
                    "callType"  : callTypeCode,
                    "qty"       : this.form.qty.toString()
                },
            }).then((res) => {
                const thread = res.data.addThread;

                // Update the local row with latest data
                Object.assign(row, thread);

                if(isNewRow){
                    this.$alertStore.success('New thread add successfully.');
                } else {
                    this.$alertStore.success('Thread update successfully.');
                }
                this.$emit('reload');
            }).catch((error) => {
                // Same reasoning as deleteRow's catch above: a real
                // ApolloError with a genuine, safe-to-show .message.
                console.error('Save thread failed:', error);
                this.$alertStore.error(error?.message || 'Failed to save thread.');
            });
        } catch (error) {
            console.error('Save thread failed:', error);
            this.$alertStore.error(error?.message || 'Failed to save thread.');
        }
    }
    },
}
  
  </script>
